<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col-1-1">
    </div>
    <div class="col-2"></div>
    <div class="col-3 bold">
      Huidige periode
    </div>
    <div class="col-4 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <ng-container *ngIf="this.showCustomControls">
    @if (isRechtspersoon) {
      <form [formGroup]="investmentsInParticipatingInterestsInGroupCompaniesFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Deelnemingen in groepsmaatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(1)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="investmentsInParticipatingInterestsOtherFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Andere deelnemingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(2)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="investmentsOtherAffiliatedCompaniesFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Deelnemingen in overige verbonden maatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(3)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    @if (isRechtspersoon) {
      <form [formGroup]="receivablesGroupCompaniesNoncurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Vorderingen op groepsmaatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(4)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    @if (isRechtspersoon) {
      <form [formGroup]="receivablesOtherAffiliatedCompaniesNoncurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Vorderingen op overige verbonden maatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(51)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="receivablesShareholdersParticipatingInterestsNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Vorderingen op andere rechtspersonen en vennootschappen die een deelneming hebben in
            de {{ isRechtspersoon ? "rechtspersoon of waarin de rechtspersoon" : "entiteit of waarin de entiteit" }} een
            deelneming heeft</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(5)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="securitiesOtherNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Langlopende overige effecten</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(6)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Vorderingen uit hoofde van leningen en voorschotten aan leden of houders van
              aandelen
              op naam</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(7)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="receivablesOtherNoncurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Overige vorderingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(8)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="deferredTaxAssetsNoncurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Latente belastingvorderingen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(9)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="financialAssetsOtherFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Overige financiële vaste activa</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(10)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="financialAssetsFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px"><b>Totaal van financiële vaste activa</b></p>
        </div>
        <div class="col-2">

        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="financialAssetsDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over financiële vaste activa</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.financialAssetsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(11)">
          {{ this.financialAssetsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over deelnemingen in groepsmaatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(12)">
            {{ this.investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="investmentsInParticipatingInterestsOtherDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over andere deelnemingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.investmentsInParticipatingInterestsOtherDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(13)">
          {{ this.investmentsInParticipatingInterestsOtherDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="investmentsOtherAffiliatedCompaniesDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over deelnemingen in overige verbonden maatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.investmentsOtherAffiliatedCompaniesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(14)">
            {{ this.investmentsOtherAffiliatedCompaniesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  @if (isRechtspersoon) {
    <form [formGroup]="receivablesGroupCompaniesNoncurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over vorderingen op groepsmaatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.receivablesGroupCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(15)">
            {{ this.receivablesGroupCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  @if (isRechtspersoon) {
    <form [formGroup]="receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over vorderingen op overige verbonden maatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(16)">
            {{ this.receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over vorderingen op andere rechtspersonen en vennootschappen die
          een deelneming hebben in
          de {{ isRechtspersoon ? "rechtspersoon of waarin de rechtspersoon" : "entiteit of waarin de entiteit" }} een
          deelneming heeft</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(17)">
          {{ this.receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="securitiesOtherNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over langlopende overige effecten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.securitiesOtherNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(18)">
          {{ this.securitiesOtherNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over vorderingen uit hoofde van leningen en voorschotten aan
            leden of houders van aandelen op naam</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(19)">
            {{ this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="receivablesOtherNoncurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over overige vorderingen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.receivablesOtherNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(20)">
          {{ this.receivablesOtherNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="deferredTaxAssetsNoncurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over latente belastingvorderingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.deferredTaxAssetsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(21)">
            {{ this.deferredTaxAssetsNoncurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.investmentsInParticipatingInterestsInGroupCompaniesFg"
                                                       [title]="'deelneming in groepsmaatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.investmentsInParticipatingInterestsOtherFg"
                                                       [title]="'andere deelnemingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.investmentsOtherAffiliatedCompaniesFg"
                                                       [title]="'deelnemingen in overige verbonden maatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesGroupCompaniesNoncurrentFg"
                                                       [title]="'vorderingen op groepsmaatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 51">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesOtherAffiliatedCompaniesNoncurrentFg"
                                                       [title]="'vorderingen op overige verbonden maatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 5">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesShareholdersParticipatingInterestsNoncurrentFg"
                                                       [title]="`vorderingen op andere rechtspersonen en vennootschappen die een deelneming hebben in de ${isRechtspersoon ? 'rechtspersoon of waarin de rechtspersoon' : 'entiteit of waarin de entiteit'} een deelneming heeft`"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 6">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.securitiesOtherNoncurrentFg"
                                                       [title]="'langlopende overige effecten'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 7">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentFg"
                                                       [title]="'vorderingen uit hoofde van leningen en voorschotten aan leden of houders van aandelen op naam'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 8">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesOtherNoncurrentFg"
                                                       [title]="'overige vorderingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 9">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.deferredTaxAssetsNoncurrentFg"
                                                       [title]="'latente belastingvorderingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 10">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.financialAssetsOtherFg"
                                                       [title]="'overige financiële vaste activa'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 11">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.financialAssetsDisclosureFg"
                                                               [title]="'Informatieverschaffing over financiële vaste activa'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 12">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.investmentsInParticipatingInterestsInGroupCompaniesDisclosureFg"
                                                               [title]="'Informatieverschaffing over deelnemingen in groepsmaatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 13">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.investmentsInParticipatingInterestsOtherDisclosureFg"
                                                               [title]="'Informatieverschaffing over andere deelnemingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 14">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.investmentsOtherAffiliatedCompaniesDisclosureFg"
                                                               [title]="'Informatieverschaffing over deelnemingen in overige verbonden maatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 15">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesGroupCompaniesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen op groepsmaatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 16">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesOtherAffiliatedCompaniesNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen op overige verbonden maatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 17">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesShareholdersParticipatingInterestsNoncurrentDisclosureFg"
                                                               [title]="`Informatieverschaffing over vorderingen op andere rechtspersonen en vennootschappen die een deelneming hebben in de ${isRechtspersoon ? 'rechtspersoon of waarin de rechtspersoon' : 'entiteit of waarin de entiteit'} een deelneming heeft`"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 18">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.securitiesOtherNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over langlopende overige effecten'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 19">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen uit hoofde van leningen en voorschotten aan leden of houders van aandelen op naam'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 20">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesOtherNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over overige vorderingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 21">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.deferredTaxAssetsNoncurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over latente belastingvorderingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
